import React from 'react';

const ModalCross = (props: any) => {
  const {disabled, fill} = props;
  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_1992_577"
        maskUnits="userSpaceOnUse"
        x="2"
        y="2"
        width="22"
        height="22"
      >
        <path
          d="M13 2L23.9519 12.9519L13.0144 23.8893L2.06256 12.9374L13 2Z"
          fill="white"
        />
      </mask>
      <g mask="url(#mask0_1992_577)">
        <path
          d="M19.5433 16.4305C18.2305 15.1176 16.9176 13.8047 15.6047 12.4919C15.6046 12.7834 15.6044 13.0749 15.6043 13.3664C16.9186 12.052 18.2331 10.7375 19.5475 9.42317C19.786 9.18463 19.7861 8.78667 19.548 8.54854C18.8237 7.82426 18.0994 7.09998 17.3752 6.3757C17.1369 6.13743 16.7391 6.13769 16.5005 6.37623C15.1862 7.69058 13.8717 9.00507 12.5573 10.3194C12.8488 10.3193 13.1403 10.3191 13.4318 10.319C12.119 9.00613 10.8061 7.69325 9.4932 6.38037C9.25493 6.1421 8.85723 6.14223 8.6187 6.38077C7.89348 7.10598 7.1684 7.83106 6.44319 8.55628C6.20492 8.79455 6.20452 9.19251 6.44279 9.43078C7.75567 10.7437 9.06856 12.0565 10.3814 13.3694C10.3816 13.0779 10.3817 12.7864 10.3818 12.4949C9.06749 13.8093 7.753 15.1238 6.43865 16.4381C6.20025 16.6765 6.19998 17.0743 6.43825 17.3126C7.16253 18.0369 7.88681 18.7612 8.61109 19.4854C8.84923 19.7236 9.24719 19.7234 9.48559 19.485C10.7999 18.1707 12.1144 16.8562 13.4288 15.5419C13.1373 15.542 12.8458 15.5421 12.5543 15.5423C13.8672 16.8551 15.18 18.168 16.4929 19.4809C16.7311 19.719 17.1289 19.7188 17.3673 19.4804C18.0924 18.7553 18.8176 18.0301 19.5427 17.305C20.107 16.7407 19.2332 15.8668 18.6688 16.4312C17.9438 17.1563 17.2185 17.8815 16.4935 18.6065C16.785 18.6064 17.0763 18.6061 17.3678 18.606C16.0549 17.2931 14.7421 15.9802 13.4292 14.6674C13.191 14.4292 12.7932 14.4295 12.5548 14.6679C11.2403 15.9824 9.92598 17.2967 8.61149 18.6112C8.90313 18.6109 9.19436 18.6108 9.48599 18.6105C8.76171 17.8863 8.03743 17.162 7.31315 16.4377C7.31289 16.7293 7.31275 17.0206 7.31249 17.3122C8.62697 15.9977 9.94132 14.6834 11.2558 13.3689C11.4942 13.1305 11.4946 12.7328 11.2563 12.4945C9.94345 11.1816 8.63057 9.86876 7.31769 8.55588C7.31742 8.84724 7.31729 9.13874 7.31716 9.43024C8.04224 8.70516 8.76745 7.97995 9.49253 7.25487C9.20103 7.255 8.90953 7.25513 8.61816 7.2554C9.93105 8.56828 11.2439 9.88117 12.5568 11.194C12.7951 11.4323 13.1926 11.4321 13.4312 11.1935C14.7457 9.87903 16.0601 8.56455 17.3745 7.2502C17.083 7.25033 16.7916 7.2506 16.5001 7.25073C17.2244 7.97501 17.9487 8.69929 18.673 9.42357C18.6731 9.13207 18.6734 8.8407 18.6735 8.5492C17.3592 9.86355 16.0447 11.178 14.7302 12.4925C14.4917 12.7311 14.4917 13.1289 14.7297 13.3669C16.0425 14.6798 17.3554 15.9927 18.6683 17.3055C19.2318 17.8691 20.1069 16.994 19.5433 16.4305Z"
          fill={disabled ? 'grey' : fill}
        />
      </g>
      <circle cx="13" cy="13" r="12" strokeWidth="2" />
    </svg>
  );
};

export default ModalCross;
